import React, { useState, useEffect } from 'react';
import { Card } from 'antd';
import './index.scss';
import Editor from './Editor';
import { getHelpMsg } from '../../api/meeting';
import { noop } from 'lodash';
import WithPrivateCheck from 'component/WithPrivateCheck';

interface IProps { }

const FeedBack: React.FC<IProps> = () => {
  const [helpMsg, setHelpMsg] = useState<string>('');

  // 获取提示信息
  useEffect(() => {
    getHelpMsg().subscribe((data) => {
      const res = JSON.parse(data.configuration).tip;
      if (res) {
        try {
          setHelpMsg(res);
        } catch (e) {
          return {};
        }
      }
    }, noop);
  }, []);

  return (
    <div className="helpAndFeed">
      {helpMsg && (
        <Card title="帮助提示" bodyStyle={{ marginLeft: 24 }}>
          <pre>{helpMsg}</pre>
        </Card>
      )}

      <Card title="服务中心" className="feedback">
        <Card type="inner" title="MAXHUB会议操作手册" bordered={false} headStyle={{ backgroundColor: 'white', border: 0 }} bodyStyle={{ paddingTop: 0 }}>
          <a href="https://help.maxhub.com/#/%E5%8A%9F%E8%83%BD%E6%A6%82%E8%A7%88/%E8%AE%BE%E5%A4%87%E8%B5%84%E4%BA%A7" target="_blank" rel="noreferrer">
            https://help.maxhub.com/
          </a>
        </Card>
        <WithPrivateCheck hide>
          <Card
            type="inner"
            title="MAXHUB 会议预约系统使用建议反馈"
            bordered={false}
            headStyle={{ backgroundColor: 'white', border: 0 }}
            bodyStyle={{ paddingTop: 0 }}
          >
            <p>感谢您的宝贵建议～</p>
            <Editor />
          </Card>
        </WithPrivateCheck>
      </Card>
    </div>
  );
};

export default FeedBack;
